import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Dropdown from "../basic/Dropdown";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SearchIcon from "@mui/icons-material/Search";
import { COLORS } from "../../constants";
import { Container } from "@mui/system";

const TabletMakeModelYearForm = ({
                                     makeOptions,
  handleUserVehicleChange,
  loading,
  variantOptions,
  yearOptions,
  modelOptions,
  userInput,
  submit,
  inputsPerRowMobile,
  darkMode,
  handleReset,
  showHeader = true,
}) => {
  return (
    <Container>
      {showHeader && (
        <>
          <Typography
            sx={{
              textAlign: "center",
              color: COLORS.white,
              textTransform: "uppercase",
              fontSize: "var(--font-size-l)",
            }}
          >
            Select your vehicle
          </Typography>
          <Typography
            sx={{
              mb: 3,
              textAlign: "center",
              color: COLORS.white,
              fontWeight: 300,
              fontSize: "var(--font-size-xxs)",
            }}
          >
            We have everything your car needs
          </Typography>
        </>
      )}
      <Grid container spacing={1.5} alignItems="center" justifyContent="center">
        {/* First Row: Dropdowns in a single row */}
        <Grid
          container
          item
          xs={12}
          spacing={1}
          sx={{ flexWrap: "nowrap" }} // Ensure dropdowns stay in one row
        >
          <Grid item xs={3}>
            <Dropdown
              loading={loading}
              disabled={loading}
              value={userInput.make}
              onChange={handleUserVehicleChange("make")}
              options={makeOptions}
              label="Make"
              darkMode={darkMode}
            />
          </Grid>
          <Grid item xs={3}>
            <Dropdown
              loading={loading}
              disabled={!userInput.make || loading}
              value={userInput.model}
              onChange={handleUserVehicleChange("model")}
              options={modelOptions}
              label="Model"
              darkMode={darkMode}
            />
          </Grid>
          <Grid item xs={3}>
            <Dropdown
              loading={loading}
              disabled={
                (!userInput.make && !userInput.model) || loading
              }
              value={userInput.variant}
              onChange={handleUserVehicleChange("variant")}
              options={variantOptions}
              label="Variant"
              darkMode={darkMode}
            />
          </Grid>
          <Grid item xs={3}>
            <Dropdown
              loading={loading}
              disabled={
                (!userInput.make &&
                  !userInput.model &&
                  !userInput.variant) ||
                loading
              }
              value={userInput.year}
              onChange={handleUserVehicleChange("year")}
              options={yearOptions}
              label="Year"
              darkMode={darkMode}
            />
          </Grid>
        </Grid>

        {/* Second Row: Buttons */}
        <Grid
          container
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 1 }}
        >
          <Grid item xs={10.3}>
            {" "}
            {/* 4/5 of 12 = 9.6 */}
            <Button
              variant="contained"
              onClick={submit}
              size="small"
              color="error"
              type="button"
              disabled={loading}
              startIcon={<SearchIcon />}
              sx={{
                backgroundColor: COLORS.themeYellow,
                color: COLORS.darkText,
                whiteSpace: "nowrap",
                padding: "0.5em 1em",
                height: 45,
                width: "100%",
                display: "flex",
                alignItems: "center",
                boxSizing: "border-box",
                borderRadius: "2px",
                fontWeight: "500",
                fontFamily: "Rubik",
                "& .MuiButton-startIcon .MuiSvgIcon-root": {
                  fontSize: "1.1rem",
                },
                "&:hover": {
                  backgroundColor: COLORS.themeBlack,
                  color: COLORS.themeYellow,
                },
              }}
            >
              SEARCH
            </Button>
          </Grid>
          <Grid item xs={1.5}>
            {/* 1/5 of 12 = 2.4 */}
            <Button
              variant="outlined"
              onClick={handleReset}
              size="small"
              disabled={loading}
              startIcon={<RestartAltIcon />}
              sx={{
                backgroundColor: COLORS.themeYellow,
                color: COLORS.darkText,
                whiteSpace: "nowrap",
                padding: "0.5em 1em",
                height: 45,
                width: "100%",
                display: "flex",
                boxSizing: "border-box",
                borderRadius: "2px",
                "& .MuiButton-startIcon": {
                  margin: 0,
                  fontSize: "1.3em",
                },
              }}
            ></Button>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TabletMakeModelYearForm;
